import React, { useRef, useCallback } from "react";
import PropTypes from "prop-types";

import { encodeUrl } from "@default/lib/encode-url";
import TeaserVenue from "@default/teasers/venue/teaser-venue";
import { changeActiveImage } from "@default/lib/change-active-image";

const VenueItem = React.memo(({ item, index, isActive }) => {
  const id = encodeUrl(`${item.label}-${item.id}`);
  const liRef = useRef(null);

  const handleClick = useCallback((e) => {
    if (!e.target.closest(".accordion__button")) return;
    const el = liRef.current;
    if (!el) return;

    const scrollContainer = el.closest(".scroll-overview");
    if (scrollContainer) {
      changeActiveImage(el, scrollContainer);
    }

    const top = el.getBoundingClientRect().top + window.scrollY - window.innerHeight * 0.5;
    window.scrollTo({ top, behavior: "smooth" });
  }, []);

  return (
    <li
      ref={liRef}
      className="scroll-overview-listener venues-scroll-item teaser-venue"
      id={id}
      data-teaser-index={index}
      aria-current={isActive}
      onClick={handleClick}
    >
      <TeaserVenue item={item} />
    </li>
  );
});

VenueItem.displayName = "VenueItem";

VenueItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.shape({ path: PropTypes.string }),
    fieldImage: PropTypes.object,
  }).isRequired,
  index: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
};

export default VenueItem;
